<template>
  <div id="content">
    <link rel="stylesheet" href="/themes/ito/css/profile.css?v=6">
    <div class="container">
      <div id="page-header-fixed" class="mb-25">
        <div class="container">
          <div id="page-header">
            <div class="buttons">
              <nav-tabs />
            </div>
          </div>
        </div>
      </div>

      <div class="card card-profile card-account">
        <div class="card-body">
          <h5 class="card-title">
            <span class="title">{{ $t('account_information') }}</span>
            <button class="ito-btn-small update-account" @click="onSubmit" :class="{ active: is_valid }" :disabled="!is_valid">{{ $t('save') }} </button>
          </h5>

          <div class="card-content">
            <div class="profile-show col-4">

              <div class="profile-avatar-upload">
                <div class="profile-avatar-upload-c" :style="{ backgroundImage: `url(${user_info.avatar_url})` }"></div>

                <a href="#" class="upload-btn" data-bs-toggle="modal" data-bs-target="#uploadAvatarModal">
                  <img src="/themes/ito/images/icon-camera-upload.svg" alt="" />
                </a>

                <div class="emoticon" v-if="user_info.emoji_url">
                  <img src="/themes/ito/images/icon-emoticon-2.svg" :src="user_info.emoji_url" alt="" />
                </div>
              </div>

              <div class="profile-avatar-info">
                <div class="profile-info-item">{{ $t('user_id') }}: <span class="value">{{ user_info.user_id
                }}</span></div>
                <div class="profile-info-item" v-show="user_info.student_type != 2">
                  <span>{{ $t('total') }}:</span>
                  <div class="profile-info-item-gem">
                    <span class="value">{{ user_info.gem | toCommas }}</span>
                    <AppIcon :src="$store.state.configs.default_gem_icon" :size="15" />
                    <span class="mx-1">|</span>
                    <span class="value">{{ user_info.crown | toCommas }}</span><i class="ito-icon-2"></i>

                  </div>
                </div>
                <div class="profile-info-item" v-show="user_info.student_type != 2">{{ $t('this_month') }}:
                  <div class="profile-info-item-gem">
                    <span class="value">{{ user_info.gem_month | toCommas }}</span>
                    <AppIcon :src="$store.state.configs.default_gem_icon" :size="15" />
                    <span class="mx-1">|</span>
                    <span class="value">{{ user_info.crown_month | toCommas }}</span><i class="ito-icon-2"></i>
                  </div>
                </div>
              </div>

              <div class="profile-avatar-button d-flex flex-column">
                <button class="btn btn-default btn-change-password" @click="changePassword()">{{
                  $t('change_password')
                }}
                </button>
                <router-link :to="{ name: 'upgrade_account' }" @click.native="getSoundClick">
                  <button class="btn btn-default btn-update btn-upgrate">{{ $t('upgrade_account') }}</button>
                </router-link>
              </div>
            </div>
            <div class="profile-update col-8">
              <form>
                <div class="row">
                  <label class="col-sm-4 col-form-label">{{ $t('username') }}</label>
                  <div class="col-sm-8">
                    <input type="text" name="username" class="form-control" v-model="user.username" :placeholder="$t('username')" disabled />
                  </div>
                </div>
                <div class="row">
                  <label class="col-sm-4 col-form-label">{{ $t('full_name') }}</label>
                  <div class="col-sm-8">
                    <input type="text" name="full_name" class="form-control" v-model="user.fullname" @input="eventValid" :placeholder="$t('full_name')" :disabled="user_info.student_type == 1" />
                    <div class="error-message has-form" v-if="errors.fullname">{{
                      errors.fullname
                    }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <label class="col-sm-4 col-form-label">{{ $t('birthday') }}</label>
                  <div class="col-sm-8">
                    <input type="text" name="birthday" class="form-control date datepicker birthday" v-model="user.birthday" autocomplete="off" :placeholder="$t('birthday')" />
                  </div>
                </div>
                <div class="row">
                  <label class="col-sm-4 col-form-label">{{ $t('gender') }}</label>
                  <div class="col-sm-8">
                    <select class="form-control" v-model="user.gender" @change="eventValid">
                      <option value="0">{{ $t('select_gender') }}</option>
                      <option value="male">{{ $t('male') }}</option>
                      <option value="female">{{ $t('female') }}</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <label class="col-sm-4 col-form-label">{{ $t('grade') }}</label>
                  <div class="col-sm-8">
                    <!--<select class="form-control" v-model="user.grade" style="width: 150px">-->
                    <!--<option value="0">{{ $t('select_grade') }}</option>-->
                    <!--<option value="1" selected>1</option>-->
                    <!--<option value="2">2</option>-->
                    <!--</select>-->
                    <input type="text" name="grade" class="form-control" :value="user.grade" disabled autocomplete="off">
                  </div>
                </div>
                <div class="row">
                  <label class="col-sm-4 col-form-label">{{ $t('account_type') }}</label>
                  <div class="col-sm-8">
                    <!--<span class="desc-blue">{{getAccountTypeText(parent_info.account_type)}}</span>-->
                    <span class="desc-blue">{{ parent_info.account_type_name }}</span>
                  </div>
                </div>
                <div class="row">
                  <label class="col-sm-4 col-form-label">{{ $t('exp_date') }}</label>
                  <div class="col-sm-8">
                    <span class="desc-blue">{{ parent_info.expired_date | convertUnitToTime('DD/MM/YYYY') }}</span>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="card card-account card-account-form">
        <div class="card-body">
          <h5 class="card-title">
            <span class="title">{{ $t('contact_details') }}</span>
            <button v-if="parent_info.student_type != 1 && update_address" class="ito-btn-small update-account" @click="onSubmitContact" :class="{ active: activeChangeContactUser }" :disabled="!activeChangeContactUser">{{ $t('save') }}
            </button>
          </h5>

          <div class="card-content">
            <div class="row">
              <div class="col-md-6">
                <label class="col-form-label">{{ $t('phone') }}</label>
                <input type="text" name="phone" class="form-control noString" v-model="contact_user.phone" @input="changeContact()" :placeholder="$t('phone')" autocomplete="off" :disabled="parent_info.student_type == 1 || !update_address" />
              </div>

              <div class="col-md-6">
                <label class="col-form-label">{{ $t('email') }}</label>
                <input type="text" name="email" class="form-control" v-model="parent_info.email" @input="changeContact()" :placeholder="$t('email')" autocomplete="off" :disabled="parent_info.student_type == 1 || !update_address" />
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <label class="col-form-label">{{ $t('address') }}</label>
                <input type="text" name="address" class="form-control" v-model="contact_user.address" @input="changeContact()" :placeholder="$t('address')" autocomplete="off" :disabled="parent_info.student_type == 1 || !update_address" />
              </div>

              <div class="col-md-6">
                <label class="col-form-label">{{ $t('country') }}</label>
                <select class="form-control" v-model="contact_user.country_id" name="country" :disabled="parent_info.student_type == 1 || !update_address" @change="changeCountry()">
                  <option value="" disabled>{{ $t('country') }}</option>
                  <template v-for="(item, key) in countries">
                    <option :value="item.id">{{ item.name }}</option>
                  </template>
                </select>
              </div>

            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="col-form-label">{{ $t('province') }}</label>
                <select class="form-control" v-model="contact_user.city_id" name="province" :disabled="parent_info.student_type == 1 || !update_address" @change="changeProvince()">
                  <option value="" disabled>{{ $t('province') }}</option>
                  <template v-for="(item, key) in provinces">
                    <option :value="item.id">{{ item.name }}</option>
                  </template>
                </select>
              </div>

              <div class="col-md-6">
                <label class="col-form-label">{{ $t('ward') }}</label>
                <select class="form-control" v-model="contact_user.ward_id" name="ward" :disabled="parent_info.student_type == 1 || !update_address">
                  <option value="" disabled>{{ $t('ward') }}</option>
                  <option :value="ward.id" v-for="ward in wards">{{ ward.name }}</option>
                </select>
              </div>
            </div>

            <!-- school infomation for non-ism account -->
            <div class="row" v-if="parent_info.student_type != 1">
              <div class="col-md-6">
                <label class="col-form-label">{{ $t('school') }}</label>
                <input type="text" name="school" class="form-control" :value="user_info.school" :placeholder="$t('school')" disabled />
              </div>

              <div class="col-md-6">
                <label class="col-form-label">{{ $t('class') }}</label>
                <input type="text" name="class" class="form-control" :value="user_info.class" :placeholder="$t('class')" disabled />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- school infomation for ism account -->
      <div class="card card-account card-account-form" v-if="parent_info.student_type == 1">
        <div class="card-body">
          <h5 class="card-title">
            <span class="title">{{ $t('school_infomation') }}</span>
          </h5>

          <div class="card-content">
            <div class="row" style="width: 100%;">
              <div class="col-md-6">
                <label class="col-form-label">{{ $t('school') }}</label>
                <input type="text" name="school" class="form-control" :value="contact_school.school" :placeholder="$t('school')" autocomplete="off" :disabled="parent_info.student_type == 1 || !update_address" />
              </div>

              <div class="col-md-6">
                <label class="col-form-label">{{ $t('class') }}</label>
                <input type="text" name="class" class="form-control" :value="contact_school.class" :placeholder="$t('class')" autocomplete="off" :disabled="parent_info.student_type == 1 || !update_address" />
              </div>
            </div>

            <div class="row" style="width: 100%;">
              <div class="col-md-6">
                <label class="col-form-label">{{ $t('address') }}</label>
                <input type="text" name="address" class="form-control" :value="contact_school.address" :title="contact_school.address" :placeholder="$t('address')" autocomplete="off" :disabled="parent_info.student_type == 1 || !update_address" />
              </div>

              <div class="col-md-6">
                <label class="col-form-label">{{ $t('ward') }}</label>
                <input type="text" name="ward" class="form-control" :value="contact_school.ward" :placeholder="$t('ward')" autocomplete="off" :disabled="parent_info.student_type == 1 || !update_address" />
              </div>
            </div>

            <div class="row" style="width: 100%;">
              <div class="col-md-6">
                <label class="col-form-label">{{ $t('province') }}</label>
                <input type="text" name="province" class="form-control" :value="contact_school.city" :placeholder="$t('province')" autocomplete="off" :disabled="parent_info.student_type == 1 || !update_address" />
              </div>

              <div class="col-md-6">
                <label class="col-form-label">{{ $t('country') }}</label>
                <input type="text" name="country" class="form-control" :value="contact_school.country" :placeholder="$t('country')" autocomplete="off" :disabled="parent_info.student_type == 1 || !update_address" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="uploadAvatarModal" tabindex="-1" aria-labelledby="uploadAvatarModal" aria-hidden="true" data-bs-backdrop="static" data-keyboard="false">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="upload-avatar">
              <div class="upload-avatar-info">
                <h3 class="title">{{ $t('student_profile') }}</h3>

                <div class="avatar">
                  <div class="avatar-wrapper">
                    <img ref="avatar_url" :src="user_info.avatar_url" alt="" class="avatar-img" />
                  </div>

                  <img ref="emoticon_url" class="emoticon" v-if="user_info.emoji_url" :src="user_info.emoji_url" alt="">
                </div>

                <button class="btn btn-default btn-update" @click="updateAvatar">
                  {{ $t('save') }}
                </button>
              </div>
              <div class="upload-avatar-select">
                <div class="upload-avatar-tabs">
                  <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">Avatar
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Emoticon
                      </button>
                    </li>
                  </ul>

                  <div class="tab-content">
                    <div class="tab-pane active" id="home" role="tabpanel" aria-labelledby="home-tab">
                      <div class="avatar-list nano">
                        <div class="nano-content">
                          <div class="row">
                            <!-- <div class="col-md-3 avatar-item" style="margin-top: 18px;">
                              <div class="thumb">
                                <div class="thumb-content">
                                  <label class="avatar-item-upload" for="uploadAvatar">
                                    <img src="/themes/ito/images/avatar-0.svg?v=2" alt="">
                                  </label>
                                </div>
                              </div>
                              <input type="file" id="uploadAvatar" name="avatar" accept="image/*" style="display: none"
                                @change="addEvent" />
                            </div> -->
                            <div class="col-md-3 avatar-item" v-for="(avatar, index) in avatars" @click="selectAvatar(avatar)">
                              <div class="thumb">
                                <div class="thumb-content">
                                  <img :src="avatar.url" alt="">

                                  <div class="avatar-item-checked" v-if="avatar.id == user.avatar_id">
                                    <i class="ito-icon-checked"></i>
                                  </div>
                                  <div class="avatar-item-gem d-flex align-items-center" v-else-if="avatar.price > 0">
                                    <span class="ito-gem">{{ avatar.price }}</span>
                                    <AppIcon :src="$store.state.configs.default_gem_icon" :size="15" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                      <div class="avatar-list nano">
                        <div class="nano-content">
                          <div class="row">
                            <div class="col-md-3 avatar-item" v-for="(emoticon, index) in emoticons" @click="selectEmoticon(emoticon)">
                              <div class="thumb">
                                <div class="thumb-content">
                                  <img :src="emoticon.url" alt="">

                                  <div class="avatar-item-checked" v-if="emoticon.id == user.emoji_id">
                                    <i class="ito-icon-checked"></i>
                                  </div>
                                  <div class="avatar-item-gem d-flex align-items-center" v-else-if="emoticon.price > 0">
                                    <span class="ito-gem">{{ emoticon.price }}</span>
                                    <AppIcon :src="$store.state.configs.default_gem_icon" :size="15" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <img class="modal-close" src="/themes/ito/images/icon-close-1.svg" alt="" data-bs-dismiss="modal" aria-label="Close" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModal" aria-hidden="true" data-keyboard="true">
      <div class="modal-dialog modal-dialog-centered" style="width: 380px;">
        <div class="modal-content">
          <div class="modal-header border-0">
            <div class="close-popup" data-bs-dismiss="modal"></div>
            <h5 class="popup-title">{{ $t('has_success') }}</h5>
          </div>
          <div class="modal-body text-center">
            <div class="message">{{ $t('profile_update_success') }}</div>
          </div>
        </div>
      </div>
    </div>

    <ChangePasswordModal></ChangePasswordModal>
    <ChangePasswordSuccessModal></ChangePasswordSuccessModal>


  </div>
</template>

<script>
import { getAvatars, updateAvatar, updateContactUser, updateProfile } from '../../models/profile'
import { changeNewPassword } from '../../models/auth'
import { getCountry, getward, getParentInfo, getProvince } from '../../models/parent'
import axios from "axios";
import { soundClick } from '../../utils/utils'
import ChangePasswordModal from '../modal/ChangePasswordModal.vue';
import ChangePasswordSuccessModal from '../modal/ChangePasswordSuccessModal.vue';
import NavTabs from '../NavTabs.vue';
import AppIcon from '@/components/common/AppIcon.vue';

export default {
  name: "ParentAcount",
  title: 'Parent - Acount',
  components: {
    ChangePasswordModal,
    ChangePasswordSuccessModal,
    NavTabs,
    AppIcon
  },

  data() {
    return {
      errors: {
        address: '',
        fullname: '',
        current_password: '',
        new_password: '',
        confirm_password: '',
      },
      user: {
        fullname: '',
        birthday: '',
        gender: '',
        grade: 0,
        type: 2,
        avatar_id: -1,
        avatar_img: '',
        emoji_id: 0,
        extension_file: 'png',
        username: ''
      },
      avatar: '',
      avatars: [],
      emoticons: [],
      current_password: '',
      new_password: '',
      confirm_password: '',
      strength: 0,
      classStrength: '',
      textStrength: '',
      parent_info: [],
      contact_user: {
        phone: "",
        phone_verified: null,
        address: "",
        ward: "",
        city: "",
        country: "",
        ward_id: null,
        city_id: null,
        country_id: null
      },
      contact_school: {
        school: "",
        class: "",
        address: "",
        ward: "",
        city: "",
        country: ""
      },
      countries: [],
      provinces: [],
      wards: [],
      is_valid: false,
      activeChangeContactUser: false,
      update_address: false
    };
  },

  computed: {
    user_info() {
      const user = this.$store.state.user_info;
      this.user.fullname = user.fullname;
      this.user.birthday = user.birthday;
      this.user.gender = user.gender;
      this.user.grade = user.grade;
      this.user.avatar_id = user.avatar_id;
      this.user.emoji_id = user.emoji_id;
      this.user.avatar_img = user.avatar_url;
      this.user.username = user.username;
      return this.$store.state.user_info
    },
    configs() {
      return this.$store.state.configs
    }
  },

  created() {
    this.$store.commit('setMenuActive', 'parent');
    this.fetch();
  },

  watch: {
    'new_password': function (newVal, oldVal) {
      this.strengPassword(newVal);
      this.errors.new_password = (newVal != this.user.username) ? 'New password cannot be  the same as the username.' : '';
    },
    'strength': function (newVal, oldVal) {
      if (newVal == 1) {
        this.classStrength = 'pw-weak';
        this.textStrength = 'Weak';
      } else if (newVal == 2) {
        this.classStrength = 'pw-normal';
        this.textStrength = 'Good';
      } else if (newVal == 3) {
        this.classStrength = 'pw-strong';
        this.textStrength = 'Strong';
      } else {
        this.classStrength = '';
        this.textStrength = '';
      }
    },
    // contact_user: {
    //   handler(val,old) {
    //     console.log(val,old)
    //     this.activeChangeContactUser = true;
    //   },
    //   deep: true
    // },
    'confirm_password': function (newVal, oldVal) {
      this.errors.confirm_password = (newVal != this.new_password) ? 'Confirm password does not match.' : '';
    },

  },

  beforeMount() {
    this.getCountries();
  },

  mounted() {

    $('.noString').keypress(function (e) {
      if (e.keyCode < 48 || e.keyCode > 57) {
        e.preventDefault();
      }
    })
  },

  methods: {
    changeContact() {
      this.activeChangeContactUser = true;
    },

    fetch() {
      const that = this;

      axios.all([
        getAvatars(),
        getParentInfo(),
      ]).then(axios.spread((response, info) => {
        if (response.data.code != 0 || info.data.code != 0) {
          return;
        }

        const items = response.data.results.items || [];

        items.forEach(function (item) {
          if (item.type == 0) {
            that.avatars.push(item)
          }
          if (item.type == 1) {
            that.emoticons.push(item)
          }
        });

        this.parent_info = info.data.results
        this.contact_user = this.parent_info.contact_user;
        this.contact_school = this.parent_info.contact_school;
        this.changeCountry(false);
        if (this.contact_user.city_id > 0) {
          this.changeProvince(false);
        }
      }));

      this.$nextTick(function () {
        //initDatepicker();

        $('.birthday').datepicker({
          dateFormat: 'dd/mm/yy',
          changeMonth: true,
          changeYear: true,
          showOtherMonths: true,
          selectOtherMonths: false,
          yearRange: '1900:+0',
          monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
        }).on('change', (e) => {
          this.searchEvent(e);
        });

        initNanoScroller();
        $('button[data-bs-toggle="tab"]').on('show.bs.tab', function (e) {
          initNanoScroller();
        });
        $('button[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
          initNanoScroller();
        });
        $('#uploadAvatarModal').on('shown.bs.modal', function () {
          initNanoScroller();
        });
      })
    },

    getCountries() {
      const that = this;
      axios.all([
        getCountry(),
      ]).then(axios.spread((report_response) => {
        that.countries = report_response.data.results;
      }));
    },

    async changeCountry(reset = true) {
      if (this.contact_user.country_id > 0 && reset) {
        this.contact_user.city_id = 0;
        this.contact_user.ward_id = 0;
        this.activeChangeContactUser = true;
      }
      const data = await getProvince({
        country_id: this.contact_user.country_id
      })
      this.provinces = data.data.results;
    },

    async changeProvince(reset = true) {
      if (this.contact_user.city_id > 0 && reset) {
        this.contact_user.ward_id = 0;
        this.activeChangeContactUser = true;
      }
      const data = await getward({
        province_id: this.contact_user.city_id
      })
      this.wards = data.data.results;
    },

    getAccountTypeText(accountType) {
      switch (accountType) {
        case 1:
          return 'FREE TRIAL';
        case 2:
          return 'STANDARD';
        case 3:
          return 'PLUS';
        case 4:
          return 'PRO';
        default:
          return "";
      }
    },

    getSoundClick() {
      soundClick();
    },

    searchEvent({ target }) {
      this.user[target.name] = target.value;
      this.is_valid = this.isChangeForm();
    },

    addEvent({ target }) {
      const that = this;

      switch (target.name) {
        case 'avatar':
          const reader = new FileReader();

          const images = target.files;

          if (images.length == 0) {
            break;
          }

          const image = images[0];

          that.avatar = image;

          //console.log(image.name)

          reader.onload = function (e) {
            that.user.avatar_id = -1;
            that.user.avatar_img = e.target.result;
            that.user.extension_file = image.name.split('.').pop();

            console.log(that.user)

            that.$refs.avatar_url.setAttribute("src", e.target.result)
          };

          if (/\.(jpe?g|png|gif)$/i.test(image.name)) {
            reader.readAsDataURL(image);
          }

          break;
      }
    },

    selectAvatar(avatar) {
      this.user.avatar_id = avatar.id;
      this.user.avatar_img = avatar.url;

      this.$refs.avatar_url.setAttribute("src", avatar.url)
    },

    selectEmoticon(emoticon) {
      this.user.emoji_id = emoticon.id;
      this.user.emoji_url = emoticon.url;

      this.$refs.emoticon_url.setAttribute("src", emoticon.url)
    },

    updateAvatar() {
      const that = this;
      const formData = new FormData();

      formData.append('avatar_id', this.user.avatar_id);
      formData.append('avatar_img', this.user.avatar_img);
      formData.append('emoji_id', this.user.emoji_id);
      formData.append('emoji_id', this.user.emoji_id);
      formData.append('type', this.user.type);
      formData.append('extension_file', this.user.extension_file);

      that.$store.commit("setLoading", true);

      updateAvatar({
        avatar_id: this.user.avatar_id,
        avatar_img: this.user.avatar_img,
        emoji_id: this.user.emoji_id,
        type: this.user.type,
        extension_file: this.user.extension_file,
        //is_raw: true
      }).then((response) => {
        that.$store.commit("setLoading", false);

        console.log(response)

        if (response.data.code != 0) {
          alert(response.data.msg)

          return;
        }

        that.user_info.avatar_id = response.data.results.avatar_id;
        that.user_info.avatar_url = response.data.results.avatar_url;
        that.user_info.emoji_id = response.data.results.emoji_id;
        that.user_info.emoji_url = response.data.results.emoji_url;

        $('#uploadAvatarModal').modal('hide');
      }).catch((response) => {
        that.$store.commit("setLoading", false);

        console.error(response)
      });
    },

    onSubmitContact(e) {
      const that = this;
      if (that.activeChangeContactUser === false) {
        return false;
      }
      const formData = new FormData();
      if (this.contact_user.phone !== "") {
        formData.append('phone', this.contact_user.phone);
      }
      if (this.parent_info.email !== "") {
        formData.append('email', this.parent_info.email);
      }
      if (this.contact_user.address !== "") {
        formData.append('address', this.contact_user.address);
      }
      formData.append('country_id', this.contact_user.country_id);
      formData.append('city_id', this.contact_user.city_id);
      formData.append('ward_id', this.contact_user.ward_id);
      that.$store.commit("setLoading", true);

      updateContactUser(formData).then((response) => {
        that.$store.commit("setLoading", false);

        console.log(response)

        if (response.data.code != 0) {
          alert(response.data.msg)

          return;
        }

        //alert('Ok')
      }).catch((response) => {
        that.$store.commit("setLoading", false);

        console.error(response)
      });

      e.preventDefault();
    },

    onSubmit(e) {
      const that = this;
      if (that.is_valid === false) {
        return false;
      }
      const formData = new FormData();

      formData.append('fullname', this.user.fullname);
      formData.append('birthday', moment(this.user.birthday, 'DD/MM/YYYY').format('YYYY-MM-DD'));
      formData.append('gender', this.user.gender);
      //formData.append('grade', this.user.grade);

      that.$store.commit("setLoading", true);

      updateProfile(formData).then((response) => {
        that.$store.commit("setLoading", false);
        if (response.data.code != 0) {
          alert(response.data.msg)
          return;
        }
        that.user_info.fullname = response.data.results.fullname;
        that.user_info.birthday = moment(response.data.results.birthday, 'YYYY-MM-DD').format('DD/MM/YYYY');
        that.user_info.gender = response.data.results.gender;
        $('#successModal').modal('show');
        that.is_valid = false;

        if (response.data.code != 0) {
          alert(response.data.msg)

          return;
        }

        //alert('Ok')
      }).catch((response) => {
        that.$store.commit("setLoading", false);

        console.error(response)
      });

      e.preventDefault();
    },

    onLogout(e) {
      this.$store.dispatch('logout').then(() => {
        // window.location.href = "/register-anomynous";
        window.location.href = "/login";
      });

      e.preventDefault();
    },

    changePassword() {
      $('#ChangePasswordPopup').modal('show');
    },

    changeNewPass() {
      const that = this;
      const formData = new FormData();

      if (that.new_password.length < 8) {
        that.errors.new_password = 'The new password must be at least 8 characters.';
        return false;
      }
      formData.append('old_pass', that.current_password)
      formData.append('new_pass', that.new_password);
      formData.append('confirm_pass', that.confirm_password);

      that.$store.commit("setLoading", true);

      changeNewPassword(formData).then((response) => {
        that.$store.commit("setLoading", false);

        console.log(response)

        if (response.data.code != 0) {
          alert(response.data.msg)

          return;
        }
        // alert('Ok');
        $('#ChangePasswordPopup').modal('hide');
        $('#changePassSuccess').modal('show');
        that.resetPasswordState();
      }).catch((response) => {
        that.$store.commit("setLoading", false);
        console.error(response)
      });
    },

    resetPasswordState() {
      this.current_password = '';
      this.new_password = '';
      this.confirm_password = '';
    },

    strengPassword(password) {
      let str1 = 0;
      let str2 = 0;
      let str3 = 0;
      (password.length >= 8) ? str1 = 1 : str1 = 0;
      (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) ? str2 = 1 : str2 = 0;
      // if (password.match(/([a-zA-Z])/) && password.match(/([0-9])/)){this.strength += 1}
      (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) ? str3 = 1 : str3 = 0;
      this.strength = str1 + str2 + str3;
    },

    timeConverter(UNIX_timestamp) {
      var a = new Date(UNIX_timestamp * 1000);
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var year = a.getFullYear();
      var month = months[a.getMonth()];
      var date = a.getDate();
      var hour = a.getHours();
      var min = a.getMinutes();
      var sec = a.getSeconds();
      var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec;
      return time;
    },

    eventValid({ target }) {
      this.is_valid = true;
      this.is_valid = this.isChangeForm();
      switch (target.name) {
        case 'full_name':
          this.errors.fullname = '';
          if (this.user.fullname.length > 50) {
            this.errors.fullname = "Fullname max 50 characters.";
            this.is_valid = false;
          }
          if (this.regexSpecialChar(this.user.fullname)) {
            this.errors.fullname = "Fullname cannot contain special characters";
            this.is_valid = false;
          }

          break;
      }
      return this.is_valid;
    },

    isChangeForm() {
      var result = false;
      if ((this.user.fullname != '' && this.user.fullname != this.user_info.fullname)
        || (this.user.gender != 0 && this.user.gender != this.user_info.gender)
        || this.user.birthday != this.user_info.birthday) {
        result = true;
      }
      console.log(result);
      return result;
    },

    regexSpecialChar(txt) {
      var specialRegex = /[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/;
      if (txt.match(specialRegex)) {
        return true;
      }
      return false;
    },
  }

}
</script>

<style scoped>
.card-account {
  margin-bottom: 15px;
}

.card-account-form .form-control {
  margin-bottom: 5px;
}

.card-account-form .card-content {
  padding: 40px 115px;
}

.avatar .avatar-wrapper {
  width: 100%;
  height: 100%;
  border-radius: 90em;
  overflow: hidden;
}

.avatar img.avatar-img {
  width: 100%;
  height: 100%;
  left: 0;
}

.update-account {
  border: none !important;
  font-size: 16px !important;
}

.error-message.has-form {
  margin-bottom: 10px;
  margin-top: -25px;
}

.thumb-content {
  left: 3px !important;
}
</style>